import React from 'react';
import Box from '@mui/material/Box';
import { observer } from 'mobx-react';
import { useStore } from '@ui/hooks/useStore';

export default function withSideBar<T extends JSX.IntrinsicAttributes>(
    Component: React.FC<T>,
) {
    return observer((props: T) => {
        const { sidebar, app } = useStore();
        const isHidden = sidebar.isSidebarHidden;
        const display = isHidden ? 'none' : '';
        const className = !app.cookiesApproved
            ? 'sidebar_with-cookies'
            : 'sidebar';
        return (
            <Box className={className} component="aside" sx={{ display }}>
                <Component {...props} />
            </Box>
        );
    });
}
